// Generated by purs version 0.11.7
"use strict";
var Data_Eq = require("../Data.Eq");
var Data_HeytingAlgebra = require("../Data.HeytingAlgebra");
var Data_Ord = require("../Data.Ord");
var Prelude = require("../Prelude");
var UP = (function () {
    function UP() {

    };
    UP.value = new UP();
    return UP;
})();
var DOWN = (function () {
    function DOWN() {

    };
    DOWN.value = new DOWN();
    return DOWN;
})();
var LEFT = (function () {
    function LEFT() {

    };
    LEFT.value = new LEFT();
    return LEFT;
})();
var RIGHT = (function () {
    function RIGHT() {

    };
    RIGHT.value = new RIGHT();
    return RIGHT;
})();
var NONE = (function () {
    function NONE() {

    };
    NONE.value = new NONE();
    return NONE;
})();
var Coord = (function () {
    function Coord(value0, value1) {
        this.value0 = value0;
        this.value1 = value1;
    };
    Coord.create = function (value0) {
        return function (value1) {
            return new Coord(value0, value1);
        };
    };
    return Coord;
})();
var eqCoord = new Data_Eq.Eq(function (v) {
    return function (v1) {
        return v.value0 === v1.value0 && v.value1 === v1.value1;
    };
});
var ordCoord = new Data_Ord.Ord(function () {
    return eqCoord;
}, function (v) {
    return function (v1) {
        var $12 = v.value0 === v1.value0;
        if ($12) {
            return Data_Ord.compare(Data_Ord.ordInt)(v.value1)(v1.value1);
        };
        return Data_Ord.compare(Data_Ord.ordInt)(v.value0)(v1.value0);
    };
});
module.exports = {
    UP: UP,
    DOWN: DOWN,
    LEFT: LEFT,
    RIGHT: RIGHT,
    NONE: NONE,
    Coord: Coord,
    eqCoord: eqCoord,
    ordCoord: ordCoord
};



//////////////////
// WEBPACK FOOTER
// ./output/Sokoban.Types/index.js
// module id = 177
// module chunks = 0